import React, { useState } from 'react';
import { Typography, Stack } from '@mui/material';
import ProfileIntakeStepPage from '../profileIntakeStepPage/ProfileIntakeStepPage';
import WholeMeUploadManagerModal from '../wholeMeProfileStory/WholeMeUploadManagerModal';
import MediaUploadButton from '../../../../common/molecules/mediaUploadButton/mediaUploadButton';
import appColors from '../../../../common/app_colors';
import appStrings from '../../../../common/app_strings';
import BottomDrawer from '../../../../common/molecules/BottomDrawer/BottomDrawer';
import { useAuthContext } from '../../../../providers/auth-provider';

const { text } = appColors;
const { wholemeIntake: { resumeUpload: { noResume, drawerTitle, drawerContent } } } = appStrings;

const ResumeUploadPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  categoryId,
  questionId,
  title,
  subtitle,
  backgroundOverlay,
  children,
  optionId,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [media, setMedia] = useState(null);
  const { user } = useAuthContext();

  const updateMedia = (mediaMeta) => {
    setMedia(mediaMeta);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  return (
    <>
      <ProfileIntakeStepPage
        paginationMeta={paginationMeta}
        title={title}
        subtitle={subtitle}
        prevButton={{ onClick: prevOnClick }}
        nextButton={{ onClick: () => nextOnClick() }}
        backgroundOverlay={backgroundOverlay}
      >
        <Stack
          spacing={2.5}
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            pt: '30px',
            pb: '-10px',
          }}
        >
          <MediaUploadButton onClickCallBack={!media ? handleOpenModal : () => {}} uploadComplete={media} />
          <Typography
            sx={{ color: text.navy, fontWeight: 600 }}
            onClick={handleDrawerOpen}
          >
            {noResume}
          </Typography>
        </Stack>
        {children}
      </ProfileIntakeStepPage>
      <WholeMeUploadManagerModal
        isOpen={modalOpen}
        handleClose={handleCloseModal}
        type="document"
        onDocumentPost={updateMedia}
        mode="upload"
        categoryId={categoryId}
        questionId={questionId}
        optionId={optionId}
        defaultTitle={`${user.first_name}'s Resume`}
      />
      <BottomDrawer
        open={drawerOpen}
        toggleDrawer={() => setDrawerOpen(!drawerOpen)}
        title={drawerTitle}
        subTitle={drawerContent}
        hideCta
        showExitIcon
        showBackdrop={drawerOpen}
        textStyleOverride={{ fontSize: '20px', fontWeight: 500 }}
      />
    </>
  );
};

export default ResumeUploadPage;
